import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [lng, setLng] = useState("en");
  const changeLanguage = () => {
    if (lng === "en") {
      setLng("ar");
      i18n.changeLanguage("ar");

      const about = document.getElementById("about");
      about.style.direction = "rtl";
      about.style.textAlignLast = "start";
      about.style.textAlign = "right";

      const menu = document.getElementById("menu");
      menu.style.flexDirection = "row-reverse";

      Array.from(document.getElementsByClassName("menu__item")).forEach(
        function (element, index, array) {
          element.style.marginRight = "0px";
          element.style.marginLeft = "35px";
        }
      );

      const aboutme = document.getElementById("about-me-ar");
      aboutme.classList.add("aboutme-ar");

      const Products = document.getElementById("Products");
      Products.style.direction = "rtl";
      Products.style.textAlignLast = "start";

      Array.from(document.getElementsByClassName("cases__item-text")).forEach(
        function (element, index, array) {
          element.classList.add("text-products");
        }
      );

      Array.from(document.getElementsByClassName("mobile-menu")).forEach(
        function (element, index, array) {
          element.style.textAlignLast = "end";
        }
      );
      const header = document.getElementById("header");

      header.style.flexFlow = "row-reverse";
    } else {
      setLng("en");
      i18n.changeLanguage("en");
      const about = document.getElementById("about");
      about.style.direction = "ltr";
      about.style.textAlign = "left";

      const aboutme = document.getElementById("about-me-ar");
      aboutme.classList.remove("aboutme-ar");

      const Products = document.getElementById("Products");
      Products.style.direction = "ltr";
      const Products2 = document.getElementsByClassName("cases__item-text");
      Array.from(document.getElementsByClassName("cases__item-text")).forEach(
        function (element, index, array) {
          element.classList.remove("text-products");
        }
      );
      Array.from(document.getElementsByClassName("mobile-menu")).forEach(
        function (element, index, array) {
          element.style.textAlignLast = " start";
        }
      );
      const header = document.getElementById("header");

      header.style.flexFlow = "";
    }
  };

  return (
    <React.Fragment>
      <header id="header" className="header">
        <a href="#" className="logo">
          <div className="logo__title">Rayan Lubbad</div>
        </a>
        <ul className="menu" id="menu">
          <li className="menu__item">
            <a href="#about" className="menu__link">
              {t("About")}
            </a>
          </li>
          <li className="menu__item">
            <a href="#services" className="menu__link">
              {" "}
              {t("Services")}
            </a>
          </li>
          <li className="menu__item">
            <a href="#Products" className="menu__link">
              {" "}
              {t("Products")}
            </a>
          </li>
          <li className="menu__item">
            <a href="#Frameworks" className="menu__link">
              {" "}
              {t("Frameworks")}
            </a>
          </li>
          <li className="menu__item">
            <a href="#Contact" className="menu__link">
              {" "}
              {t("Contact me")}
            </a>
          </li>
        </ul>
        <div className="header__right">
          <div className="lng" onClick={changeLanguage}>
          {lng === "en" ? "العربية" : "English"}
          </div>
        </div>
        <div class="btn-menu">
          <div class="one"></div>
          <div class="two"></div>
          <div class="three"></div>
        </div>
      </header>
      <div className="fixed-menu">
        <div className="fixed-menu__header">
          <a href="#" className="logo">
            <div className="logo__title">Rayan Lubbad</div>
          </a>
          <div className="btn-close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              version="1.1"
              x="0px"
              y="0px"
              viewBox="0 0 47.971 47.971"
              style={{ enableBackground: "new 0 0 47.971 47.971" }}
              xmlSpace="preserve"
              width="512px"
              height="512px"
            >
              <path
                d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88   c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242   C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879   s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"
                fill="#006DF0"
              />
            </svg>
          </div>
        </div>
        <div className="fixed-menu__content">
          <ul className="mob-menu mobile-menu">
            <li className="mob-menu__item">
              <a href="#about" className="mob-menu__link">
                {t("About")}
              </a>
            </li>
            <li className="mob-menu__item">
              <a href="#services" className="mob-menu__link">
                {t("Services")}
              </a>
            </li>
            <li className="mob-menu__item">
              <a href="#Products" className="mob-menu__link">
                {t("Products")}
              </a>
            </li>
            <li className="mob-menu__item">
              <a href="#Frameworks" className="mob-menu__link">
                {t("Frameworks")}
              </a>
            </li>
            <li className="mob-menu__item">
              <a href="#Contact" className="mob-menu__link">
                {t("Contact me")}
              </a>
            </li>
          </ul>
          <div className="mobile-menu">
            <div className="lng" onClick={changeLanguage}>
              {lng === "en" ? "العربية" : "English"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Header;
